import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import StartScreen from './components/StartScreen';
import MainMenu from './components/MainMenu';
import Jornada from './components/sections/Jornada';
import Habilidades from './components/sections/Habilidades';
import Projetos from './components/sections/Projetos';
import Experiencias from './components/sections/Experiencias';
import AchievementsSection from './components/sections/AchievementsSection';
import Contato from './components/sections/Contato';
import GameElements from './components/GameElements';
import GameCharacter from './components/GameCharacter';
import KeyboardControls from './components/KeyboardControls';
import AudioManager from './components/AudioManager';
import { useAudio } from './context/AudioContext';

const AppContent: React.FC = () => {
   const [showMenu, setShowMenu] = React.useState(false);
  const [userHasInteracted, setUserHasInteracted] = useState(false);
  const navigate = useNavigate();

  const { playMusic } = useAudio();

  useEffect(() => {
    const handleFirstInteraction = () => {
      setUserHasInteracted(true);
      window.removeEventListener('click', handleFirstInteraction);
      window.removeEventListener('keypress', handleFirstInteraction);
    };

    window.addEventListener('click', handleFirstInteraction);
    window.addEventListener('keypress', handleFirstInteraction);

    return () => {
      window.removeEventListener('click', handleFirstInteraction);
      window.removeEventListener('keypress', handleFirstInteraction);
    };
  }, []);

  useEffect(() => {
    if (userHasInteracted) {
      playMusic('/audio/digimon-lofi.mp3', true);
    }
  }, [userHasInteracted, playMusic]);
  
  const handleStart = () => setShowMenu(true);
  const handleBackToMenu = () => {
    setShowMenu(true);
    navigate('/');
  };
  const handleNavigate = (section: string) => navigate(`/${section}`);

  return (
    <>
      <GlobalStyles />
      <GameElements />
      <GameCharacter />
      <KeyboardControls />
      <AudioManager />

      <Routes>
        <Route
          path="/"
          element={
            showMenu ? (
              <MainMenu onNavigate={handleNavigate} />
            ) : (
              <StartScreen onStart={handleStart} />
            )
          }
        />
        <Route path="/journey" element={<Jornada onBack={handleBackToMenu} />} />
        <Route path="/skills" element={<Habilidades onBack={handleBackToMenu} />} />
        <Route path="/projects" element={<Projetos onBack={handleBackToMenu} />} />
        <Route path="/experiences" element={<Experiencias onBack={handleBackToMenu} />} />
        <Route path="/achievements" element={<AchievementsSection onBack={handleBackToMenu} />} />
        <Route path="/contact" element={<Contato onBack={handleBackToMenu} />} />
      </Routes>
    </>
  );
};


const App: React.FC = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
